export default {
  order_amount: '订单金额',
  transaction_fee_charge_mode: '手续费承担模式',
  transaction_fee_charge_mode1: '商户承担',
  transaction_fee_charge_mode2: '用户承担',
  merchant_main_name: '账户名',
  merchant_no: '商户编号',
  merchant_name: '商户名称',
  merchant_type: '商户类型',
  merchant_origin: '入户渠道',
  industry_category: '公司性质',
  add_merchant: '添加商户',
  service_fee: '服务费',
  settlement_bank: '结算银行名称',
  settlement_bank_account: '结算账户名称',
  settlement_bank_num: '结算账号',
  contract_effect_time: '合同生效时间',
  contract_validity_start: '合同起始日',
  contract_validity_end: '合同终止日',
  merchant_status: '合同生效状态',
  merchant_payment_type: '商户支持业务',
  payment_combination: '支付组合费率',
  payout_combination: '代付组合费率',
  channel_fee_id: '渠道费率ID',
  payment_institution_name: '支付机构',
  fee_type: '收费类型',
  payment_institution_contract_costs: '支付机构签约成本',
  external_quotation: 'Unlock对外报价',
  unlock_quotation: 'Unlock报价',
  fee_structure: '收费模式',
  combination_name: '组合费率名称',
  available_channels: '可用渠道',
  legal_person_name: '法人名字',
  legal_person_mobile: '法人电话',
  legal_person_id_num_type: '法人证件类型',
  legal_person_id_num: '法人证件号码',
  legal_person_email: '法人邮箱',
  contract_name: '联系人姓名',
  contract_mobile: '联系人手机号码',
  contract_id_num_type: '联系人证件类型',
  contract_id_num: '联系人证件号码',
  contract_email: '联系人邮箱',
  legal_person_id_num_upload: '身份证证件照上传',
  upload_id_face_card: '上传证件正面照片,',
  upload_id_back_card: '上传证件背面照片,',
  contract_validity_period: '合同有效日期',
  legal_person_id_num_info: '法人身份证信息',
  add_merchant_app: '添加商户应用',
  update_merchant_app: '更新商户应用',
  merchant_app_detail: '商户应用详情',
  callback_event_list: '回调事件列表',
  app_name: '应用名称',
  appkey: 'AppId',
  notice_webhook: '商户回调接口',
  qrcode_webhook: 'QRPH回调接口',
  transfer_webhook: 'Transfer回调接口',
  collect_url: '商户确认接口',
  validate_url: '商户查询接口',
  public_key: '公钥',
  secret_key: '秘钥',
  white_ips: 'IP 白名单',
  ips_tips: '(IP用逗号隔开不要有空格)',
  account_open_time: '开户时间',
  to: '至',
  merchant_basic_info: '商户基本信息',
  account_name: '银行账户持有人',
  account_num: '银行账号',
  account_bank: '银行名称',
  withdrawal_account: '提现账户',
  account_address: '银行地址',
  company_address: '公司地址',
  recharge: '充值',
  withdraw: '提现',
  bank_list: '银行列表',
  account_balance: '账户余额',
  bank_payee: '收款银行',
  payment_institution: '支付渠道',
  payout_institution: '代付渠道',
  choose_bank_payee: '选择收款银行',
  payment_channel: '支付渠道',
  institute_name: '通道名称',
  level_id: '风险等级',
  institute_rate_type: '费率类型',
  institute_cost: '渠道成本',
  institute_cost_step_begin: '梯度起点',
  institute_cost_step_end: '梯度终点',
  profile_pic: '头像',
  merchant_logo: '商户Logo',
  settlement_method: '结算方式',
  notification_email: '通知邮箱',
  notification_phone: '通知手机',
  jt_institute_way_code: '支付通道'
}
